<template>
  <div class="subsector landfills">
    <div class="parent-sector">
      <p>Waste</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-sm-6">
          <h1>Landfills</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Landfilling of solid waste includes emissions associated with
                the disposal of municipal solid waste (MSW) and industrial solid
                waste. Landfills produce CH₄ and other landfill gases, primarily
                CO₂, through the natural process of bacterial decomposition of
                organic waste under anaerobic conditions.
              </p>
              <p>
                Despite stable or even increased waste generation in many OECD
                countries, landfill emissions from OECD countries are projected
                to remain relatively flat, increasing about 4% from 2015 through
                2030, with an associated decrease in their global contribution
                to total landfill emissions from 32% to 25% by 2030. The decline
                in the proportion of landfill emissions from OECD countries is
                due to this region’s relatively lower population growth and use
                of landfill disposal compared with other regions. In other
                regions, emissions from landfilling solid waste are projected to
                increase at a greater rate. Driving factors for landfill
                emission trends include growing populations, increases in
                personal income, and urbanization.
              </p>
              <p>
                Global abatement potential from solid waste landfills is
                estimated to be approximately 635 MtCO₂e in 2030, or 53% of the
                baseline emissions. Slightly more than half of all potential
                abatement can be achieved at break-even prices below $20/tCO₂e;
                31% of reductions can be achieved at prices below $0/tCO₂e,
                suggesting a substantial share of abatement could generate
                revenue for landfill operators.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartLandfills1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartLandfills2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartLandfills1 from "@/components/waste/ChartLandfills1";
import ChartLandfills2 from "@/components/waste/ChartLandfills2";

export default {
  components: {
    ChartLandfills1,
    ChartLandfills2
  },
  data() {
    return {
      currentComp: "ChartLandfills1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-brown-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #4c300e;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
